// Stores the Google Ads gclid parameter from the page URL in sessionStorage so
// it remains accessible throughout the user's current browser session even after navigating to other pages.
const GCLID_PARAM = 'gclid';

const storeGclid = () => {
  const inIframe = window.self !== window.top;
  let search = window.location.search;

  if (inIframe) {
    try {
      search = window.top.location.search;
    } catch {
      // Cross-origin iframe — fall back to iframe's own URL
    }
  }

  const params = new URLSearchParams(search);
  const gclid = params.get(GCLID_PARAM);

  if (gclid) {
    sessionStorage.setItem(GCLID_PARAM, gclid);

    if (inIframe) {
      try {
        window.top.sessionStorage.setItem(GCLID_PARAM, gclid);
      } catch {
        // Cross-origin iframe — top sessionStorage inaccessible
      }
    }
  }
};

export const getGclid = () => {
  return sessionStorage.getItem(GCLID_PARAM);
};

// Store defined marketing tags so they may be later used.
const storeMarketingTags = () => {
  storeGclid();
};

export default storeMarketingTags;
